/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAccountGenericTileViewProps } from '@msdyn365-commerce-modules/account-management';
const AccountGenericTileView: React.FC<IAccountGenericTileViewProps> = props => {
    const { AccountGenericTile, heading, links } = props;

    return (
        <Module {...AccountGenericTile}>
            {heading}
            <p className="ms-account-address-tile__description">View or Edit Profile</p>
            {links}
        </Module>
    );
};

export default AccountGenericTileView;
